import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("stylee_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 handler: emits a window event so the Admin page can react
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("stylee_token")) {
      localStorage.removeItem("stylee_token");
      window.dispatchEvent(new CustomEvent("stylee:unauth"));
    }
    return Promise.reject(err);
  },
);

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d39d2d63-666a-4336-b80b-599ff949fb6f/artifacts/dc0iff4w_StyleePix%20Collective%202026%20Logo.png";

export const SOCIALS = {
  instagram: "https://instagram.com/styleepix",
  behance: "https://behance.net/styleepix",
  linkedin: "https://www.linkedin.com/company/styleepix/",
  youtube: "https://youtube.com/@styleepix",
  email: "hello@styleepix.co",
};
